<template>
  <div class="q-pa-md">
    <platforms-loader :social-sites="platforms" @loaded="onLoaded" />
    <q-list class="rounded-borders full-height" bordered>
      <div
        v-for="platform in platforms"
        :key="platform.id"
        >
        <q-expansion-item
          :model-value="isActive(platform.id)"
          header-class="bg-white"
          :header-style="{ position: 'sticky', top: '-16px', left: 0, right: 0, zIndex: 100 }"
          group="platforms"
          @update:model-value="onToggle($event, platform)"
        >
          <template v-slot:header>
            <q-item-section side>
              <platform-icon :social-site="platform" size="2rem" class="on-left" />
            </q-item-section>
            <slot name="header" v-bind="{ platform, isActive: isActive(platform.id) }">
              <q-item-section>
                <div class="text-body1" :class="{ 'text-weight-bold': isActive(platform.id) }">
                  {{ platform.name }}
                </div>
              </q-item-section>
            </slot>
          </template>
          <slot v-bind="{ platform }" />
        </q-expansion-item>
        <q-separator />
      </div>
    </q-list>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Platform } from '@/social/types';
import PlatformsLoader from './SitesLoader.vue';
import PlatformIcon from './SiteIcon.vue';

export default defineComponent({
  emits: ['loaded', 'update:modelValue'],
  components: {
    PlatformIcon,
    PlatformsLoader,
  },
  props: {
    platforms: {
      type: Array as () => Platform[],
      default: () => [],
    },
    modelValue: Object as () => Platform,
  },
  methods: {
    onLoaded(platforms: Platform[]) {
      this.$emit('loaded', platforms);
    },
    isActive(platformId: number): boolean {
      return (this.modelValue && this.modelValue.id === platformId);
    },
    onToggle(open: boolean, platform: Platform): void {
      if (open) {
        this.$emit('update:modelValue', platform);
      }
    },
  },
});
</script>
